
// import talents from '@/router/modules/talents'
import router from '@/router'
import { defineComponent, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getPlayerData, getRequire } from './unit'
export default defineComponent({
    components: {},
    props: {},
    setup() {
        const route = useRoute()
        let currentPlayer = JSON.parse((route.query.currentPlayer as string) || '')

        const navToDetail = (type) => {
            router.push({
                name: 'Content',
                query: {
                    name: currentPlayer.name,
                    type: type,
                    category: 'Player',
                },
            })
            // if (type === '详细视频拆解') {
            //     router.push({
            //         name: 'worldCupPanelData',
            //         query: {
            //             name: currentPlayer.name,
            //         },
            //     })
            // } else {
            //     router.push({
            //         name: 'Content',
            //         query: {
            //             name: currentPlayer.name,
            //             type: type,
            //             category: 'Player',
            //         },
            //     })
            // }
        }
        return {
            navToDetail,
            currentPlayer,
            getRequire,
            isLongName: (name) => {
                return name && name.length > 4
            },
        }
    },
})
